import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ICONS } from '../../../../_helpers/icons.constants';

@Component({
  selector: 'text-and-description-renderer',
  templateUrl: './text-and-description-renderer.component.html',
  standalone: true,
  imports: [TranslateModule]
})
export class TextAndDescriptionRendererComponent implements ICellRendererAngularComp {
  text: string;
  description: string;
  isMandatory: boolean = false;
  isIcon: boolean = false;
  classValue: string;
  constructor(private translate: TranslateService) { }
  public ICONS = ICONS;
  initilize(params: ICellRendererParams) {
    let data = params.getValue();

    if (data) {
      this.text = this.translate.instant(data.text);
      this.isIcon = params.colDef?.headerComponentParams?.isIcon;
      this.isMandatory = params.data?.isMandatory;
      this.description = data.description ? this.translate.instant(data.description) : '';      
    this.classValue = params.colDef?.headerComponentParams?.class;
    }

    //delete it after testing 
    // this.text = this.translate.instant("text example");
    // this.description = this.translate.instant("description example");
    // this.classValue = params.colDef.headerComponentParams?.class;

  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}
